import { authFetch } from './http/fetchClient';
import { APIUrl } from 'Utils/Utils';

export interface SasUrlResponse {
  file_url: string;
  expires_at: string;
  size_bytes: number;
}

// Both the DocPreview panel (pdf/docx/xlsx/csv) and generated-image
// resolution (generatedImageCache.ts) hit this same backend endpoint —
// shared here so the URL construction and auth header can't drift between
// the two. Returns the raw Response rather than parsed/classified data:
// the two callers need genuinely different error handling (DocPreview
// shows a full classified error card for a whole panel; an image thumbnail
// just needs a simple ok/fail), so only the actual HTTP mechanics are
// shared, not the interpretation of the result.
export async function fetchSasUrl(path: string, userId: string, signal?: AbortSignal): Promise<Response> {
  const params = new URLSearchParams({ path });
  return authFetch(`${APIUrl()}/adls/sas_url?${params}`, { signal });
}
